import React from 'react';

import Avatar from 'components/Avatar';
import Table from 'components/Table';

import {MemberStatus} from 'containers/MyTeams/components/shared';

const MembersTable = ({members}) => {
  return (
    <div className="membersSection">
      <div className="header">
        <div className="heading">Members</div>
      </div>
      <div className="tableContainer">
        <div className="tableHeader">
          <Table>
            <Table.Header>
              <Table.HeaderItem className="name" heading="name" />
              <Table.HeaderItem className="email" heading="email" />
              <Table.HeaderItem className="type" heading="type" />
              <Table.HeaderItem className="status" heading="colab status" />
            </Table.Header>
          </Table>
        </div>
        <div className="tableBody">
          <Table>
            <Table.Body>
              {members.map(member => (
                <Table.Row key={member.id}>
                  <Table.Cell className="name">
                    <div className="info">
                      <Avatar
                        url={
                          member.internalAvatarCropped || member.avatarCropped
                        }
                        initials={member.initials}
                      />
                      <div className="text">
                        <div className="fullName">{member.fullName}</div>
                        <div className="jobTitle">{member.jobTitle}</div>
                      </div>
                    </div>
                  </Table.Cell>
                  <Table.Cell className="email">{member.email}</Table.Cell>
                  <Table.Cell className="type">
                    {member.isOwner ? 'Team Owner' : 'Team Member'}
                  </Table.Cell>
                  <Table.Cell className="status">
                    <MemberStatus status={member.status} />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default MembersTable;
